var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indicator-status",class:_vm.activeStatus})
}
var staticRenderFns = []

export { render, staticRenderFns }